<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useTutorDetailMenu } from '../model/tutor-detail-menu.hook'

defineOptions({
  name: 'TutorDetailMenu',
})

const {
  config,
} = useTutorDetailMenu()
</script>

<template>
  <NavigationLinkTabs
    :config="config"
  />
</template>
